// extracted by mini-css-extract-plugin
export default {"editor":"crop_editor__mlAT2","banner":"crop_banner__4z5H1","cropper":"crop_cropper__2yq70","slide-in-bottom":"crop_slide-in-bottom__+WoSn"};